import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Tooltip } from '@reveni-io/reveni-ui'

import { getViewVisibilityIndicator } from './helpers'
import * as Styles from './styles'

const ViewVisibilityIndicator = ({ view }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { Icon, label, count } = getViewVisibilityIndicator(view)

  return (
    <Tooltip title={t(label, { count })}>
      <Styles.Container>
        <Icon size={20} color={theme.colors.text.inverse} />
      </Styles.Container>
    </Tooltip>
  )
}

export default ViewVisibilityIndicator
